import { render, staticRenderFns } from "./BusinessCategoriesView.vue?vue&type=template&id=72bdeedf&scoped=true"
import script from "./BusinessCategoriesView.vue?vue&type=script&lang=js"
export * from "./BusinessCategoriesView.vue?vue&type=script&lang=js"
import style0 from "./BusinessCategoriesView.vue?vue&type=style&index=0&id=72bdeedf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bdeedf",
  null
  
)

export default component.exports